import { EQueryIdType } from './types';

export const idOptions = [
  {
    label: 'User ID',
    value: EQueryIdType.userId,
  },
  {
    label: 'Client ID',
    value: EQueryIdType.clientId,
  },
];
